module.exports = __webpack_public_path__ + "img/mask.4ea5f99a.png";